export const preventDefault = (event, stopPropagation = false) => {
    event.preventDefault();
    if (stopPropagation) event.stopPropagation();
};

export const stopPropagation = event => preventDefault(event, true);
